import { PlatformType } from '../types/project';

interface PlatformConfig {
  displayName: string;
  shortName: string;
  linkButtonTitle: string;
  generateButtonLabel: string;
}

export const PLATFORM_CONFIG: Record<PlatformType, PlatformConfig> = {
  [PlatformType.ServiceNow]: {
    displayName: 'ServiceNow',
    shortName: 'SN',
    linkButtonTitle: 'Link ServiceNow Site',
    generateButtonLabel: 'Generate SN Prototype',
  },
  [PlatformType.PowerApps]: {
    displayName: 'PowerApps',
    shortName: 'PA',
    linkButtonTitle: 'Link PowerApps Site',
    generateButtonLabel: 'Generate PA Prototype',
  },
  [PlatformType.TylerAppPlatform]: {
    displayName: 'TAP',
    shortName: 'TAP',
    linkButtonTitle: 'Link Tap Site',
    generateButtonLabel: 'Generate TAP Prototype',
  },
  [PlatformType.Salesforce]: {
    displayName: 'Salesforce',
    shortName: 'SF',
    linkButtonTitle: 'Link Salesforce Site',
    generateButtonLabel: 'Generate SF Prototype',
  },
};

export const getPlatformConfig = (platformType?: PlatformType): PlatformConfig => {
  return PLATFORM_CONFIG[platformType || PlatformType.TylerAppPlatform];
};

export const getPlatformDisplayName = (platformType?: PlatformType): string => {
  return getPlatformConfig(platformType).displayName;
};

// One badge style for every application type, not the old per-platform rainbow
// (blue/purple/orange/pink/green) that clashed with the Veylo chartreuse+neutral
// palette. Web, SN, PA, SF and TAP all render as the same plain neutral pill.
// `_platformType` and `_isWeb` are kept so callers do not have to change and the
// distinction can be reintroduced later if design asks for it.
export const getPlatformBadgeClass = (_platformType?: PlatformType, _isWeb?: boolean): string => {
  return 'bg-bg-primary border border-border-primary text-text-primary';
};
